var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uiv-tooltip',_vm._g(_vm._b({ref:"uivPopup",on:{"show":_vm.onShow,"hide":_vm.onHide}},'uiv-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }